var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"footer content-section"},[_c('el-col',{attrs:{"xs":24,"md":12}},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1),_c('li',[_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("Contact")])],1)])]),_c('el-col',{attrs:{"xs":24,"md":12}},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/privacy"}},[_vm._v("Privacy policy")])],1)])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17aaa5a7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/AppFooter.vue
// module id = null
// module chunks = 